const $ = jQuery;

class StickyImageScroll {
	constructor(block) {
		this.sections = block.querySelectorAll('.block-sticky-image-section');
		this.scrollPositions = [];
		this.images = block.querySelectorAll('.block-sticky-image-scroll__img');

		if (!this.images.length || !this.sections.length) {
			return;
		}

		this.activeSection = this.sections[0];
		this.images[0].classList.add('active');

		this.setScrollPositions();
		window.addEventListener('scroll', this.handleScroll.bind(this), { passive: true });
		window.addEventListener('resize', this.handleResize.bind(this), { passive: true });
		window.addEventListener('load', this.handleResize.bind(this));
	}

	handleResize() {
		this.setScrollPositions();
		this.handleScroll();
	}

	setScrollPositions() {
		this.scrollPositions = [];

		this.sections.forEach((section) => {
			const offsetTop = $(section).offset().top;

			this.scrollPositions.push({
				obj: section,
				center: offsetTop + section.offsetHeight / 2,
			});
		});
	}

	handleScroll() {
		let scrollPos = window.scrollY;

		const headerHeight = getComputedStyle(document.documentElement).getPropertyValue(
			'--headerHeightFull'
		);

		if (headerHeight) {
			scrollPos = scrollPos + window.innerHeight / 2;
		}

		let closest = null;
		this.scrollPositions.forEach((section) => {
			if (
				null === closest ||
				Math.abs(scrollPos - section.center) < Math.abs(scrollPos - closest)
			) {
				closest = section.center;
				this.setActiveSection(section.obj);
			}
		});
	}

	setActiveSection(section) {
		const activeImg = document.querySelector(`[data-block-id="${section.id}"]`);
		if (null !== activeImg) {
			this.images.forEach((img) => {
				img.classList.remove('active');
			});

			activeImg.classList.add('active');
			this.activeSection = section;
		}
	}
}

const blocks = document.querySelectorAll('.block-sticky-image-scroll');
blocks.forEach((block) => {
	new StickyImageScroll(block);
});
